import createBehavior from '@js/functions/createBehavior.js';

const scrollRevealBehavior = createBehavior(
  'scroll-reveal',
  {
    bindUI() {
      this.els = this.getChildren('element');
    },
    bindEvents() {
      document.addEventListener('page:updated', this.resetBehavior, false);
      document.addEventListener('focus', this.focusCheck, true);
    },
    buildObserver(el) {
      // Create options.
      const options = {
        rootMargin: '0px 0px -15% 0px'
      };

      // Create new observer.
      this.observer = new IntersectionObserver(this.updatePage, options);

      // Observe all elements.
      Array.from(this.els).map(el => {
        this.observer.observe(el);
      });
    },
    resetBehavior() {
      this.bindUI();
      this.buildObserver();
      this.bindEvents();
    },
    revealElement(el) {
      el.classList.add('is-visible');
      this.observer.unobserve(el);
      setTimeout(() => {
        el.classList.add('is-animation-done');
      }, 700);
    },
    updatePage(entries, observer) {
      // Add class when we reach the element.
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.revealElement(entry.target);
        }
      });
    },
    disconnectObserver() {
      this.observer.disconnect();
    },
    focusCheck() {
      this.els.forEach(el => {
        if (el === document.activeElement || el.contains(document.activeElement)) {
          this.revealElement(el);
        }
      });
    },
  },
  {
    init() {
      this.observer = null;

      this.bindUI();
      this.buildObserver();
      this.bindEvents();
    },
    destroy() {
      document.removeEventListener('page:updated', this.resetBehavior);
      document.removeEventListener('focus', this.focusCheck);
      this.disconnectObserver();
    }
  }
);

export default scrollRevealBehavior;
